var strings = {
    notifications: {
        attemptToCollectDebt: 'Este es un intento de cobrar una deuda y toda información que se obtenga se utilizará para este propósito.',
        attentionRequired: 'Se requiere su atención.',
        autopayFutureNotify: 'El pago automático de %minAmountDue% ocurrirá en %daysToDueDate% días.',
        autopayTodayNotify: 'El pago automático de %minAmountDue% ocurrirá el día de hoy.',
        autopayTomorrowNotify: 'El pago automático de %minAmountDue% ocurrirá en 1 día.',
        closedWithBalance: 'Esta cuenta está cerrada.',
        enrolledPaymentPlan: 'Inscrito en un plan de pago.',
        issueWithAccount: 'Hay un problema con su cuenta. Llame al servicio de atención al cliente al 1-800-542-5593.',
        loanPaidOffNotify: '¡Felicidades, este préstamo está saldado!',
        minimizeNotification: 'Minimizar Notificacion',
        noPaymentDueNotify: 'Sin pago mínimo adeudado.',
        notifications: 'Notificaciones',
        pastDueNotify: 'Su pago está en mora.',
        pastDueNotifyMessage: 'Este es un intento de cobrar una deuda y toda información que se obtenga se utilizará para este propósito.',
        paymentDueFutureNotify: 'Su pago se vence en %numberOfDaysToDueDate% días.',
        paymentDueTodayNotify: 'Su pago se vence hoy.',
        paymentDueTomorrowNotify: 'Su pago se vence en 1 día.',
        paymentProcessingNotify: 'Su pago de %amountPaid% se está procesando.',
        paymentScheduledFutureNotify: 'El pago programado de %payAmount% ocurrirá en %numberOfDaysToDueDate% días.',
        paymentScheduledTodayNotify: 'El pago programado de %payAmount% ocurrirá el día de hoy.',
        paymentScheduledTomorrowNotify: 'El pago programado de %payAmount% ocurrirá en 1 día.',
        registerAccountNotify: 'Regístrese hoy y tenga acceso a su cuenta.',
        waivedInterestPromotionExpired: 'Este préstamo está fuera del período promocional de Exención de Interés y ya no es elegible para que todos los intereses sean eximidos.',
        promotionExpired: 'El período promocional ha vencido.',
        waivedInterestPromotionExpiring: 'El período promocional de Exención de Interés está por vencer. Para la exención del interés en este préstamo, usted debe hacer un pago por un total de $%payOffBalance% hasta %promoEndDate%.',
        promotionExpiring: 'El período promocional está por vencer.'
    }
};
export default strings;
